const USER_KEY = "wp_user_session";

export type SessionUser = {
  nombre: string;
  email: string;
  roles: string[]; // normalizados, ej: ["EVENT_ADMIN", "FACTOR_PASSWORD"]
};

function normalizeRoles(roles: string[]) {
  return roles.map((r) => (r.startsWith("ROLE_") ? r.replace("ROLE_", "") : r));
}

export function setSessionUser(user: SessionUser) {
  const normalized: SessionUser = {
    ...user,
    roles: normalizeRoles(user.roles),
  };
  localStorage.setItem(USER_KEY, JSON.stringify(normalized));
}

export function getSessionUser(): SessionUser | null {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as SessionUser;
  } catch {
    return null;
  }
}

export function clearSessionUser() {
  localStorage.removeItem(USER_KEY);
}